import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { Dropdown } from "antd";

import { revertNameAvatar } from "../../../helpers/common";
import { getToken } from "../../../helpers/tokenMain";

import { ModalRegister } from "../../Modal/ModalRegister";

import { REFRESH_TOKEN_KEY } from "../../../utils/common";

import { logoutAction } from "../../../stores/user";

const Account = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [showModalRegister, setShowModalRegister] = useState(false);

    const closeModal = useSelector((state) => state.user.closeModalRegister);
    const authentication = useSelector((state) => state.user.authentication);
    const currentUser = useSelector((state) => state.user.currentUser);

    const accountPopup = () => (
        <div className="account">
            {(currentUser?.isMaster || currentUser?.isSuper) && <p onClick={handleShowModalRegister}>Register User</p>}
            <p onClick={handleMyAccount}>My Account</p>
            <p onClick={handleLogout}>Log Out</p>
        </div>
    );

    const handleMyAccount = () => {
        history.push(`/admin/my-details`);
    };

    const handleLogout = () => {
        const token = getToken(REFRESH_TOKEN_KEY);
        if (token) {
            dispatch(
                logoutAction({
                    search: token,
                })
            );
        }
    };

    const handleShowModalRegister = () => {
        setShowModalRegister(true);
    };

    const handleCancelModalRegister = () => {
        setShowModalRegister(false);
    };

    useEffect(() => {
        if (closeModal) setShowModalRegister(false);
    }, [closeModal]);

    return (
        <>
            {authentication && (
                <Dropdown
                    overlay={accountPopup}
                    placement="bottom"
                    trigger={["click"]}
                    className="account-popup"
                >
                    {currentUser?.avatarImg ? (
                        <img src={currentUser?.avatarImg} alt="avatar" />
                    ) : (
                        <p>{revertNameAvatar(currentUser?.fullName)}</p>
                    )}
                </Dropdown>
            )}
            {showModalRegister && (
                <ModalRegister
                    visible={showModalRegister}
                    handleCancel={handleCancelModalRegister}
                />
            )}
        </>
    );
};

export default Account;
